var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 23C40.1046 23 41.0454 22.0899 40.7951 21.0141C40.1723 18.338 38.0897 17 34 17C29.9103 17 27.8277 18.338 27.2049 21.0141C26.9546 22.0899 27.8954 23 29 23H39Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 14C36 14 37 13 37 10.5C37 8 36 7 34 7C32 7 31 8 31 10.5C31 13 32 14 34 14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 23C40.1046 23 41.0454 22.0899 40.7951 21.0141C40.1723 18.338 38.0897 17 34 17C29.9103 17 27.8277 18.338 27.2049 21.0141C26.9546 22.0899 27.8954 23 29 23H39Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 14C36 14 37 13 37 10.5C37 8 36 7 34 7C32 7 31 8 31 10.5C31 13 32 14 34 14Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.652 28.5661C12.8553 27.6511 13.667 27 14.6044 27H15.3957C16.3331 27 17.1447 27.6511 17.3481 28.5661L17.551 29.4794C18.2121 29.7382 18.8243 30.0947 19.3697 30.5311L20.2639 30.2496C21.1581 29.9682 22.1277 30.3455 22.5964 31.1573L22.9921 31.8426C23.4608 32.6545 23.3027 33.6829 22.6119 34.3165L21.9217 34.9496C21.9733 35.2922 22 35.643 22 36C22 36.357 21.9733 36.7078 21.9217 37.0504L22.6119 37.6835C23.3028 38.3171 23.4608 39.3455 22.9921 40.1574L22.5964 40.8426C22.1277 41.6545 21.1581 42.0318 20.2639 41.7504L19.3697 41.4689C18.8243 41.9053 18.2121 42.2618 17.551 42.5206L17.3481 43.4339C17.1447 44.3489 16.3331 45 15.3957 45H14.6044C13.667 45 12.8553 44.3489 12.652 43.4339L12.4491 42.5206C11.7879 42.2618 11.1758 41.9053 10.6303 41.4689L9.73611 41.7504C8.84196 42.0318 7.87231 41.6545 7.40361 40.8426L7.00795 40.1573C6.53925 39.3455 6.69728 38.3171 7.38808 37.6835L8.0783 37.0504C8.02675 36.7077 8.00002 36.357 8.00002 36C8.00002 35.643 8.02675 35.2922 8.0783 34.9496L7.38809 34.3165C6.69729 33.6829 6.53927 32.6545 7.00797 31.8426L7.40362 31.1574C7.87232 30.3455 8.84197 29.9682 9.73613 30.2496L10.6303 30.5311C11.1758 30.0947 11.7879 29.7382 12.4491 29.4794L12.652 28.5661Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 36C16 36.5523 15.5523 37 15 37C14.4477 37 14 36.5523 14 36C14 35.4477 14.4477 35 15 35C15.5523 35 16 35.4477 16 36Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2581 21.9422L9.74056 20.8763C7.43536 16.1278 11.9431 10.9311 16.9696 12.5423L21.7101 14.0618M21.7101 14.0618L16.68 16.6499M21.7101 14.0618L19.122 9.03176",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.51 29L38.3282 29.8571C41.9728 33.6753 39.2665 40 33.9881 40L29.01 40M29.01 40L33.01 36M29.01 40L33.01 44",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppImg2);
export default __webpack_public_path__ + "static/media/appImg2.db3b8c14fae4eb5e0775cd041e941136.svg";
export { ForwardRef as ReactComponent };